<template>
	<app-title-bar
		:icon="['fas', 'fa-truck']"
		subtitle="Hire Desk"
		title="Journey Detail"
		:badges="[
			journey?.link_number,
			journey?.journey_number,
			journey?.account_name,
			journeyTypeBadge,
			vehicleInfoBadge
		]">
		<div class="flex gap-3">
			<app-button to="/hire-desk" icon="fa-circle-left"> Back </app-button>

			<resource-details :loading="loading || !journey" :resource="journey" />

			<status-badge
				v-if="journey?.status && journey.status.length > 0"
				:status="journey.status[0]"
				status-key="journey_status" />
		</div>
	</app-title-bar>

	<div class="flex flex-col-reverse 2xl:flex-row gap-4">
		<app-panel class="grow" title="Journey Items">
			<template #header>
				<div class="flex items-center gap-3">
					<app-badge
						v-for="(weight, depot) in weightByDepot"
						:key="depot"
						theme="info"
						size="small"
						class="gap-1 py-2">
						<font-awesome-icon icon="fa-solid fa-weight-hanging" class="w-4" />
						<b>{{ depot }}:</b> {{ Math.round(weight * 100) / 100 }}
					</app-badge>
				</div>
			</template>

			<item-details-table :items="items" :loading="loading" />
		</app-panel>
	</div>
</template>

<script lang="ts" setup>
	import { ref, onMounted, computed } from 'vue'
	import ItemDetailsTable from '@/components/datatables/hire-desk/journey/ItemDetailsTable.vue'
	import { useRoute } from 'vue-router'
	import StatusBadge from '@/components/partials/cat2/StatusBadge.vue'
	import type { JourneyItem } from '@/data/schema/journey-item'
	import type { Journey } from '@/data/schema/journey'
	import JourneyService from '@/services/journey'
	import ResourceDetails from '@/components/partials/panels/ResourceDetails.vue'
	import { splitWeightByDepot } from '@/utils/contract-items'

	// Resources
	const api = new JourneyService()
	const route = useRoute()

	// Data
	const journeyNumber = ref()
	const loading = ref(true)
	const journey = ref<Journey>()
	const items = ref<JourneyItem[]>([])
	const weightByDepot = computed(() => {
		return splitWeightByDepot(items.value, 'journey')
	})

	const journeyTypeBadge = computed(() => {
		return journey.value ? journey.value.type_name : ''
	})

	const vehicleInfoBadge = computed(() => {
		return journey.value
			? `${journey.value.vehicle_display_name} - ${journey.value.vehicle_name}`
			: ''
	})
	/**
	 * Get journey and journey item data
	 */
	async function getData() {
		loading.value = true

		api.get(journeyNumber.value, { withItems: true })
			.then((res) => {
				journey.value = res.data.data
				items.value = journey.value!.items
				loading.value = false
			})
			.catch((error) => {
				console.error(error)
			})
	}

	onMounted(() => {
		journeyNumber.value = route.params.id

		if (journeyNumber.value) {
			getData()
		}
	})
</script>
